import { render } from "./cemsPublicity.vue?vue&type=template&id=626d128c&scoped=true"
import script from "./cemsPublicity.vue?vue&type=script&lang=js"
export * from "./cemsPublicity.vue?vue&type=script&lang=js"

import "./cemsPublicity.vue?vue&type=style&index=0&id=626d128c&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626d128c"]])

export default __exports__